import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api, clearToken, getToken } from "@/lib/api";

export default function RequireAdmin({ children }) {
  const [status, setStatus] = useState("checking"); // checking | ok | denied

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setStatus("denied");
      return;
    }
    api
      .get("/auth/me")
      .then(() => setStatus("ok"))
      .catch(() => {
        clearToken();
        setStatus("denied");
      });
  }, []);

  if (status === "checking") {
    return (
      <div
        data-testid="admin-loading"
        className="min-h-screen flex items-center justify-center bg-paper text-ink-muted eyebrow"
      >
        Verifying credentials…
      </div>
    );
  }
  if (status === "denied") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
